export enum TipoMessaggioNotifica {
    Errore,
    Warning,
    Info
}